// Where cues play while one of your Khronos Timers follows the session
// (issue #45): this app, the timer, or both. A per-browser choice — a phone
// propped by the timer and a laptop across the room want different answers —
// so it lives in the local audio settings and is never synced to the account.

export const AUDIO_OUTPUTS = [
  {
    value: "both",
    label: "App and timer",
    description: "Both play every cue",
  },
  {
    value: "app",
    label: "This app",
    description: "The timer stays quiet for the session",
  },
  {
    value: "device",
    label: "Khronos Timer",
    description: "This app stays quiet while the timer follows along",
  },
];

export const DEFAULT_AUDIO_OUTPUT = "both";

export const resolveAudioOutput = (value) =>
  AUDIO_OUTPUTS.some((o) => o.value === value) ? value : DEFAULT_AUDIO_OUTPUT;

export const audioOutputLabel = (value) =>
  AUDIO_OUTPUTS.find((o) => o.value === resolveAudioOutput(value)).label;

// Whether a timer of yours is following the current session. Module state
// rather than React state so playSound can read it at call time, the same way
// it reads the audio settings from localStorage.
let timerFollowing = false;

export function setTimerFollowing(following) {
  timerFollowing = !!following;
}

/** Whether this app should drop a cue. Never with no timer attached. */
export const appCuesSilenced = (output) =>
  timerFollowing && resolveAudioOutput(output) === "device";

/** The timer's `audio.muted` value the chosen output asks for. */
export const timerMutedFor = (output) => resolveAudioOutput(output) === "app";
